export default __webpack_public_path__ + "static/media/credentials.fd59d4a4.png";